module.exports = __webpack_public_path__ + "static/img/the-last-new-nodata-imag.67f32708.png";